export const COMPANY_DROPDOWN_FIELD_TYPE = '18';
export const shouldApplyCompanyDropdownLogo = (pathname, embeddedPreview = false) => {
    if (embeddedPreview)
        return true;
    return pathname.includes('/form') || pathname.includes('/success');
};
export const findCompanyDropdownFieldId = (formSteps) => {
    if (!formSteps?.length)
        return null;
    for (const step of formSteps) {
        const field = step.formFields?.find((formField) => String(formField.fieldType) === COMPANY_DROPDOWN_FIELD_TYPE);
        if (field)
            return field.id;
    }
    return null;
};
export const isExternalCompanyDropdownValue = (value, eventCompanies) => {
    if (value === null || value === undefined || value === '')
        return false;
    const numericValue = Number(value);
    if (isNaN(numericValue))
        return true;
    return numericValue <= 0 || numericValue > eventCompanies.length;
};
export const resolveSelectedCompanyFromDropdownValue = (value, eventCompanies) => {
    if (value === null || value === undefined || value === '')
        return null;
    if (isExternalCompanyDropdownValue(value, eventCompanies)) {
        return {
            label: String(value),
            value: String(value),
            logoUrl: null,
            isExternal: true
        };
    }
    return eventCompanies[Number(value) - 1] ?? null;
};
export const resolveVdkGroepHeaderLogo = (vdkGroepLogoSrc) => ({
    headerLogo: { src: vdkGroepLogoSrc, alt: 'VDK Groep' },
    showPartOfVdk: false
});
export const resolveRegistrationHeaderLogo = (company, vdkGroepLogoSrc) => {
    const label = company?.label ?? '';
    const isVdkGroep = String(label).toLowerCase().includes('vdk');
    if (company.isExternal || !company.logoUrl) {
        return resolveVdkGroepHeaderLogo(vdkGroepLogoSrc);
    }
    return {
        headerLogo: { src: company.logoUrl, alt: label || 'Company' },
        showPartOfVdk: Boolean(label) && !isVdkGroep
    };
};
export const resolveDefaultRegistrationHeaderLogo = (eventCompanies, vdkGroepLogoSrc) => {
    if (eventCompanies.length > 1) {
        return resolveVdkGroepHeaderLogo(vdkGroepLogoSrc);
    }
    return resolveRegistrationHeaderLogo(eventCompanies[0] ?? {}, vdkGroepLogoSrc);
};
